import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const TOAST_DURATION_MS = 3500;
const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  const hideTimerRef = useRef(null);

  const clearToastTimer = useCallback(() => {
    if (hideTimerRef.current) {
      window.clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }
  }, []);

  const hideToast = useCallback(() => {
    clearToastTimer();
    setToast(null);
  }, [clearToastTimer]);

  const showToast = useCallback((message, tone = 'success') => {
    clearToastTimer();
    setToast({
      id: Date.now(),
      message,
      tone,
    });

    hideTimerRef.current = window.setTimeout(() => {
      setToast(null);
      hideTimerRef.current = null;
    }, TOAST_DURATION_MS);
  }, [clearToastTimer]);

  const value = useMemo(() => ({
    toast,
    showToast,
    hideToast,
  }), [toast, showToast, hideToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used inside ToastProvider');
  }
  return context;
}
